import { useCallback } from "react";
import apiClient from "../api/apiClient";
import API_CONFIG from "../config/api";
import useBusinessResource from "../hooks/useBusinessResource";

const EMPTY_OPTIONS = { categories: [], suppliers: [] };

export default function useExpenseFormOptions({
  userId, companyId, warehouseId, moduleScope, enabled, formOpen,
}) {
  const resource = useBusinessResource({
    resource: "expense-form-options", userId, companyId, warehouseId, moduleScope,
    enabled, active: formOpen,
    load: async (signal) => {
      const response = await apiClient.get(API_CONFIG.apiUrl("/expenses/form-options"), {
        signal, headers: { "X-Company-Id": companyId },
        params: { company_id: companyId, warehouse_id: warehouseId, module_scope: moduleScope },
      });
      if (!Array.isArray(response.data?.categories) || !Array.isArray(response.data?.suppliers)) {
        throw new Error("Réponse des listes de choix invalide.");
      }
      return response.data;
    },
  });
  const { refresh: refreshResource, updatedAt, error } = resource;
  // Event handlers expose the query error through the notice; avoid an
  // unhandled rejected promise when a retry is triggered by a button.
  const refresh = useCallback(() => refreshResource().catch(() => undefined), [refreshResource]);
  const onChoiceOpen = useCallback((open) => {
    if (open && (error || Date.now() - updatedAt >= 30_000)) void refresh().catch(() => {});
  }, [error, updatedAt, refresh]);
  const options = resource.data || EMPTY_OPTIONS;
  return {
    categories: options.categories, suppliers: options.suppliers,
    loading: resource.loading, refresh, onChoiceOpen,
    error: resource.error ? resource.data
      ? "Impossible d’actualiser les catégories et les fournisseurs. Les dernières listes disponibles sont conservées."
      : "Impossible de charger les catégories et les fournisseurs." : "",
  };
}
